export default {
  state: {
    formData: { },
    processedData: []
  },
  getters: {
    getFormData: state => {
      return state.formData
    },
    getProcessedData: state => {
      return state.processedData
    }
  },
  mutations: {
    setFormData (state, formData) {
      state.formData = formData
    },
    SET_PROCESSED_DATA (state, payload) {
      state.processedData = payload
    }
  },
  actions: {
    updateFormData ({commit}, formData) {
      commit('setFormData', formData)
    },
    updateProcessedData ({commit}, payload) {
      commit('SET_PROCESSED_DATA', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/forms.js